import { IImageGenerationCategories } from "pages/imageCreator/components/ExampleModal";

export const imageGenerationCategories: IImageGenerationCategories[] = [
  {
    name: "Anime Style",
    style: "Anime",
    prefectForShort: "Fans, Profiles",
    perfectFor:
      "Anime fans, cosplayers, fan art creators, social media profiles",
    basicTemplate:
      "A [character/scene description] in [specific anime style] style, [lighting], [mood], [additional details]",
    parameterizedTemplate:
      "A [character description] in [setting/scene], [specific anime style] style, [color palette] colors, [lighting] light, [mood] atmosphere, [optional: additional details], [aspect ratio] aspect ratio",
    examples: [
      {
        image: "/images/categorie-anime-case1.png",
        content:
          "A young woman with long flowing hair sitting under a cherry blossom tree, Studio Ghibli style, soft pastel colors, morning light filtering through branches, peaceful atmosphere, reading a book, butterflies nearby",
      },
      {
        image: "/images/categorie-anime-case2.png",
        content:
          "A samurai warrior with a glowing katana facing a demon in a moonlit bamboo forest, dynamic action pose, shonen anime style, dark blue and purple colors, dramatic backlighting, tense atmosphere, speed lines, sparks from the blade",
      },
      {
        image: "/images/categorie-anime-case3.png",
        content:
          "A cyberpunk hacker with neon blue hair and augmented reality glasses in a futuristic Tokyo cityscape, anime style, vibrant neon colors against dark backgrounds, night time with city lights, mysterious atmosphere, holographic displays, rain-slicked streets",
      },
    ],
    isExpanded: false,
    image: "/images/categorie-anime.png",
  },
  {
    name: "Portraits",
    style: "Portraits",
    perfectFor:
      "Social media profiles, gaming avatars, professional headshots, character concepts",
    prefectForShort: "Social",
    basicTemplate:
      "A portrait of a [person description] as a [character type], [style], [lighting], [details]",
    parameterizedTemplate:
      "A [portrait type] portrait of [subject description] [optional: as character type], [style], [lighting], [camera specifications], [mood/expression], [optional: background/setting], [aspect ratio] aspect ratio",
    examples: [
      {
        image: "/images/categorie-portraits-case1.png",
        content:
          "A professional portrait of a middle-aged man in a navy suit against a neutral background, corporate photography style, soft professional lighting, 50mm lens, confident expression, shallow depth of field",
      },
      {
        image: "/images/categorie-portraits-case2.png",
        content:
          "A stylized portrait of a young woman with colorful hair in cyberpunk style, digital art, neon rim lighting on dark background, wide angle lens, mysterious smirk, tech elements and holographic overlays",
      },
    ],
    isExpanded: false,
    image: "/images/categorie-portraits.png",
  },
  {
    name: "Product Photography & Marketing",
    style: "Product",
    perfectFor:
      "Small business owners, e-commerce sellers, marketers, content creators",
    prefectForShort: "Marketing",
    basicTemplate:
      "A professional photo of [product] in [setting], [lighting], [style], [photography specifics]",
    parameterizedTemplate:
      "A [photography type] photo of [product] on/in [setting/background], [lighting], [photography specifications], [style], [optional: text/logo details], [aspect ratio] aspect ratio",
    examples: [
      {
        image: "/images/categorie-product-case1.png",
        content:
          "A minimalist product photo of a white ceramic coffee mug on a wooden table, morning sunlight from the side, shallow depth of field, commercial photography style, clean background with soft shadows",
      },
      {
        image: "/images/categorie-product-case2.png",
        content:
          'A professional photo of a gourmet burger with melting cheese and fresh vegetables on a rustic wooden board, dramatic studio lighting, overhead angle, food photography style with rich colors, include text "PREMIUM TASTE" in modern bold font at the bottom',
      },
      {
        image: "/images/categorie-product-case3.png",
        content:
          'A lifestyle photo of wireless headphones being used by a person in a modern coffee shop, warm ambient lighting, 35mm lens with bokeh background, trendy Instagram style, include minimalist logo "SoundScape" in corner, people working on laptops in soft focus background',
      },
    ],
    isExpanded: false,
    image: "/images/categorie-product.png",
  },
  {
    name: "Memes & Social Content",
    style: "Memes",
    perfectFor: "Social media content creators, marketers, community managers",
    prefectForShort: "Social media",
    basicTemplate:
      "A [style] image of [subject] [doing action], [expression], [format details]",
    parameterizedTemplate:
      "A [style] image of [subject] [action/situation], [expression/details], [background], [optional: meme format/text placement], [aspect ratio] aspect ratio",
    examples: [
      {
        image: "/images/categorie-memes-case1.png",
        content:
          "A digital art image of a surprised cat wearing glasses looking at a computer screen, shocked expression with wide eyes, simple desk background, include text placement area at top and bottom for meme format",
      },
      {
        image: "/images/categorie-memes-case2.png",
        content:
          'A stylized photo of a mountain summit at sunrise with a silhouette of a person with arms raised, inspiring scene with golden light, dramatic clouds, include text "THE CLIMB IS WORTH IT" in bold white font at the center, motivational social media post',
      },
      {
        image: "/images/categorie-memes-case3.png",
        content:
          "A 2-panel comic strip showing a dog and cat having a conversation, cartoon style with clean lines, the dog looking confused in first panel, the cat smirking in second panel, simple living room background, include speech bubble areas in each panel, humorous situation",
      },
    ],
    isExpanded: false,
    image: "/images/categorie-memes.png",
  },
  {
    name: "Artistic Illustrations",
    style: "Illustrations",
    perfectFor:
      "Writers, bloggers, educators, presenters, marketers & web developers",
    prefectForShort: "Writers",
    parameterizedTemplate:
      "A [medium] [style] illustration of [subject] [action/situation], [color scheme], [mood], [optional: specific details], [purpose indication], [aspect ratio] aspect ratio",
    examples: [
      {
        image: "/images/categorie-illustrations-case1.png",
        content:
          "A clean vector illustration of a business workflow diagram showing data flowing between users, cloud services, and analytics, blue and white corporate color scheme, professional mood, simple icons with connecting arrows, for presentation slide",
      },
      {
        image: "/images/categorie-illustrations-case2.png",
        content:
          "A watercolor illustration of diverse children planting trees in a community garden, bright cheerful colors, joyful mood, butterflies and birds in the scene, detailed plants and flowers, for educational content",
      },
    ],
    isExpanded: false,
    image: "/images/categorie-illustrations.png",
  },
  {
    name: "Photo Editing & Transformations",
    style: "Photo Editing",
    perfectFor:
      "Content creators, social media users, marketers, photographers",
    prefectForShort: "Content creators",
    parameterizedTemplate:
      "A [photo quality] photo of [subject] with [edit/transformation description], [style], [lighting], [mood], [optional: technical details], [aspect ratio] aspect ratio",
    examples: [
      {
        image: "/images/categorie-photo-editing-case1.png",
        content:
          "A professional photo of a person in business attire with background changed to modern office environment, photorealistic style, natural studio lighting, professional mood, seamless integration, shallow depth of field",
      },
      {
        image: "/images/categorie-photo-editing-case2.png",
        content:
          "A photo of a landscape transformed from summer to winter scene, snow covering the trees and ground, dramatic photography style, late afternoon light with long shadows, peaceful atmosphere, maintaining original perspective and elements",
      },
      {
        image: "/images/categorie-photo-editing-case3.png",
        content:
          "A photo of an urban street scene transformed into watercolor painting style, vibrant artistic colors, soft diffused lighting, nostalgic mood, preserving architectural details while adding artistic elements, impressionist technique",
      },
    ],
    isExpanded: false,
    image: "/images/categorie-photo-editing.png",
  },
  {
    name: "Logo, Print & Marketing",
    style: "Logo",
    perfectFor:
      "Marketers, content creators, advertisers, social media managers",
    prefectForShort: "Marketers",
    parameterizedTemplate:
      "A [design type] with the text '[primary text]' [text position/description], [optional: secondary text], [style], [background/scene], [color scheme], [purpose], [aspect ratio] aspect ratio",
    examples: [
      {
        image: "/images/categorie-logo-case1.png",
        content:
          'A festive banner with the text "SUMMER SALE" in large playful font at the top, "50% OFF EVERYTHING" in medium size below it, beach theme style, tropical background with palm trees and ocean, bright sunny colors, for email campaign header',
      },
      {
        image: "/images/categorie-logo-case2.png",
        content:
          "A modern logo design with the text \"EVERGREEN\" in sophisticated serif font, positioned centrally with small leaf icon integrated into the letter 'E', minimalist style, subtle green and gray color scheme on white background, for business branding",
      },
    ],
    isExpanded: false,
    image: "/images/categorie-logo.png",
  },
];
